__turbopack_context__.v({
  "barContentLayout": "ES2rZW_barContentLayout",
  "barLayoutWidth": "ES2rZW_barLayoutWidth",
  "desktopMenuWrapper": "ES2rZW_desktopMenuWrapper",
  "desktopMenuWrapperFixed": "ES2rZW_desktopMenuWrapperFixed",
  "menuItemContainer": "ES2rZW_menuItemContainer",
  "moneyBreaking": "ES2rZW_moneyBreaking",
  "navbarPlaceholder": "ES2rZW_navbarPlaceholder",
  "premiumBtn": "ES2rZW_premiumBtn",
  "primaryMenuWrapper": "ES2rZW_primaryMenuWrapper",
  "primaryNavButton": "ES2rZW_primaryNavButton",
  "secondaryMenuWrapper": "ES2rZW_secondaryMenuWrapper",
  "tertiaryMenuWrap": "ES2rZW_tertiaryMenuWrap",
  "whiteBar": "ES2rZW_whiteBar",
  "whiteBarBordered": "ES2rZW_whiteBarBordered",
});
